// Single source for the API origin — used by api-client, sw-registration,
// und cache-policies. VITE_API_BASE_URL kommt aus .env.local oder dem
// build-env (prod: https://hitzeprotokoll.de).
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? "").replace(/\/$/, "") || "/";

// Build-stamp für update-checks. CI setzt VITE_APP_VERSION via build-hash;
// lokal default "dev". Zeigt sich in settings → app-info.
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "dev";
